import React, { useEffect, useState } from "react";
import "../../../../../Assets/Styles/AIServiceMonitoring.scss";
import Collapsible from "react-collapsible";
import { Config } from "../../../../../Config";
import axios from "axios";
import { formatDate, translateText } from "../../../../../Helper_functions";
import InfoModal from "../SystemMetrics/Modal";

const AIServiceMonitoring = (props) => {
  const [JPARecommendationIsOpen, setJPARecommendationIsOpen] = useState(true);
  const [CandidateRecommendationIsOpen, setCandidateRecommendationIsOpen] =
    useState(false);
  const [SkillRecommendationIsOpen, setSkillRecommendationIsOpen] =
    useState(false);
  const [DemandForecastingIsOpen, setDemandForecastingIsOpen] = useState(false);
  const [TableItems, setTableItems] = useState({
    jpa_recommendation_batch: { Status: "DOWN", LastUpdate: "" },
    jpa_recommendation_single: { Status: "DOWN", LastUpdate: "" },
    jpa_recommendation_similar: { Status: "DOWN", LastUpdate: "" },
    candidate_recommendation_periodic: { Status: "DOWN", LastUpdate: "" },
    candidate_recommendation_online: { Status: "DOWN", LastUpdate: "" },
    candidate_recommendation_chatbot: { Status: "DOWN", LastUpdate: "" },
    candidate_recommendation_manual: { Status: "DOWN", LastUpdate: "" },
    skill_recommendation_batch: { Status: "DOWN", LastUpdate: "" },
    skill_recommendation_single: { Status: "DOWN", LastUpdate: "" },
    demand_forecasting_job: { Status: "DOWN", LastUpdate: "" },
    demand_forecasting_skill: { Status: "DOWN", LastUpdate: "" },
  });
  const [Modal, setModal] = useState({
    isOpen: false,
    data: undefined,
  });

  const TableInfo = {
    TableHeadTitle: translateText("al_service_monitoring", props.LangData),
    TableContentTitle: translateText("ai_services", props.LangData),
    TableContentsInfo: [
      {
        id: 1,
        LabelId: "JPA_recommendation",
        SubTitle: translateText("jpa_recommendation", props.LangData),
        ContentItems: [
          {
            id: 11,
            LabelId: "jpa_recommendation_batch",
            Name: translateText("batch_recommendation", props.LangData),
            ModalDescription: translateText(
              "jpa_recommendation_info_1",
              props.LangData
            ),
          },
          {
            id: 12,
            LabelId: "jpa_recommendation_single",
            Name: translateText("single_recommendation", props.LangData),
            ModalDescription: translateText(
              "jpa_recommendation_info_2",
              props.LangData
            ),
          },
          {
            id: 13,
            LabelId: "jpa_recommendation_similar",
            Name: translateText(
              "similar_vacancies_recommendation",
              props.LangData
            ),
            ModalDescription: translateText(
              "jpa_recommendation_info_3",
              props.LangData
            ),
          },
        ],
      },
      {
        id: 2,
        LabelId: "candidate_recommendation",
        SubTitle: translateText("candidate_recommendation", props.LangData),
        ContentItems: [
          {
            id: 21,
            LabelId: "candidate_recommendation_periodic",
            Name: translateText("periodic_recommendation", props.LangData),
            ModalDescription: translateText(
              "jpa_recommendation_info_4",
              props.LangData
            ),
          },
          {
            id: 22,
            LabelId: "candidate_recommendation_online",
            Name: translateText("online_recommendation", props.LangData),
            ModalDescription: translateText(
              "jpa_recommendation_info_5",
              props.LangData
            ),
          },
          {
            id: 23,
            LabelId: "candidate_recommendation_chatbot",
            Name: translateText("chatbot_recommendation", props.LangData),
            ModalDescription: translateText(
              "jpa_recommendation_info_6",
              props.LangData
            ),
          },
          {
            id: 24,
            LabelId: "candidate_recommendation_manual",
            Name: translateText("manual_recommendation", props.LangData),
            ModalDescription: translateText(
              "jpa_recommendation_info_7",
              props.LangData
            ),
          },
        ],
      },
      {
        id: 3,
        LabelId: "skill_recommendation",
        SubTitle: translateText("skill_recommendation", props.LangData),
        ContentItems: [
          {
            id: 31,
            LabelId: "skill_recommendation_batch",
            Name: translateText("batch_recommendation", props.LangData),
            ModalDescription: translateText(
              "jpa_recommendation_info_8",
              props.LangData
            ),
          },
          {
            id: 32,
            LabelId: "skill_recommendation_single",
            Name: translateText("single_recommendation", props.LangData),
            ModalDescription: translateText(
              "jpa_recommendation_info_9",
              props.LangData
            ),
          },
        ],
      },
      {
        id: 4,
        LabelId: "demand_forecasting",
        SubTitle: translateText("demand_forcasting", props.LangData),
        ContentItems: [
          {
            id: 41,
            LabelId: "demand_forecasting_job",
            Name: translateText("job_demand_forecast", props.LangData),
            ModalDescription: translateText(
              "jpa_recommendation_info_10",
              props.LangData
            ),
          },
          {
            id: 42,
            LabelId: "demand_forecasting_skill",
            Name: translateText("skill_demand_forecast", props.LangData),
            ModalDescription: translateText(
              "jpa_recommendation_info_10",
              props.LangData
            ),
          },
        ],
      },
    ],
  };

  const { TableHeadTitle, TableContentTitle, TableContentsInfo } = TableInfo;

  // collapsibleName: JPA_recommendation | candidate_recommendation | skill_recommendation | demand_forecasting
  // action: boolean
  const handleCollapsibleOpen = (collapsibleName, action) => {
    switch (collapsibleName) {
      case "JPA_recommendation":
        setJPARecommendationIsOpen(action);
        break;
      case "candidate_recommendation":
        setCandidateRecommendationIsOpen(action);
        break;
      case "skill_recommendation":
        setSkillRecommendationIsOpen(action);
        break;
      case "demand_forecasting":
        setDemandForecastingIsOpen(action);
    }
  };

  const handleCollapsibleArrowStyling = (collapsibleName) => {
    switch (collapsibleName) {
      case "JPA_recommendation":
        return JPARecommendationIsOpen ? "i-rotated" : "";
      case "candidate_recommendation":
        return CandidateRecommendationIsOpen ? "i-rotated" : "";
      case "skill_recommendation":
        return SkillRecommendationIsOpen ? "i-rotated" : "";
      case "demand_forecasting":
        return DemandForecastingIsOpen ? "i-rotated" : "";
    }
  };

  const handleLastUpdate = (dateFormat) => {
    if (dateFormat) {
      return `${formatDate(dateFormat)} at ${new Date(
        dateFormat
      ).toLocaleTimeString()}`;
    }
    return null;
  };

  const getAIStatus = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/services-monitoring/ai-services",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req).then((Res) => {
      // change response from array to object because the list from API is not formatted in order
      setTableItems((prevState) => {
        let newState = {};
        for (let i = 0; i < Res.data?.length; i++) {
          newState[Res.data[i].name] = {
            Status: Res.data[i].status,
            LastUpdate: handleLastUpdate(Res.data[i]?.lastUpdatedDate),
          };
        }
        return {
          ...prevState,
          ...newState,
        };
      });
    });
  };

  const handleModal = (SectionName, RowName, Text) => {
    setModal({
      isOpen: true,
      data: { section: SectionName, row: RowName, text: Text },
    });
  };

  useEffect(() => {
    getAIStatus();
  }, []);

  return (
    <div className="table-wrapper ai-services-table-wrapper">
      {Modal.isOpen ? (
        <InfoModal
          Close={() => setModal({ isOpen: false, data: Modal.data })}
          LangData={props.LangData}
          Data={Modal.data}
          Text={Modal.data.text}
          ShowIcon={true}
        />
      ) : null}
      <div className="table-head ai-services-table-head">{TableHeadTitle}</div>
      <div className="table-content">
        <div className="table-content-title">{TableContentTitle}</div>
        {window.innerWidth <= 450
          ? TableContentsInfo.map((Content) => (
              <Collapsible
                onOpening={() => handleCollapsibleOpen(Content.LabelId, true)}
                onClose={() => handleCollapsibleOpen(Content.LabelId, false)}
                transitionTime={200}
                open={Content.LabelId === "JPA_recommendation"}
                trigger={
                  <div className="trigger">
                    <div className="section-title">
                      {translateText(Content.SubTitle, props.LangData)}
                    </div>
                    <i
                      className={
                        "feather-chevron-down " +
                        handleCollapsibleArrowStyling(Content.LabelId)
                      }
                    />
                  </div>
                }
                key={Content.id}
              >
                {Content.ContentItems.map((Item) => (
                  <div className="table-content-item" key={Item.id}>
                    <div className="column-left">
                      <div className="table-content-item-name">
                        <span>{Item.Name}</span>
                        <i
                          className="feather-info"
                          onClick={() =>
                            handleModal(
                              Content.SubTitle,
                              Item.Name,
                              Item.ModalDescription
                            )
                          }
                        ></i>
                      </div>
                      <div className="table-content-item-last-update">
                        {TableItems[Item.LabelId]?.LastUpdate
                          ? `${translateText(
                              "last_update_on",
                              props.LangData
                            )} ${TableItems[Item.LabelId]?.LastUpdate}`
                          : "Service unavailable"}
                      </div>
                    </div>
                    <div
                      className={
                        "table-content-item-status " +
                        TableItems[Item.LabelId]?.Status
                      }
                    >
                      {TableItems[Item.LabelId]?.Status === "UP" ? "on" : "off"}
                    </div>
                  </div>
                ))}
              </Collapsible>
            ))
          : TableContentsInfo.map((Content) => (
              <div className="table-row" key={Content.id}>
                <div className="table-content-sub-title">
                  {Content.SubTitle}
                </div>
                {Content.ContentItems.map((Item) => (
                  <div className="table-content-item" key={Item.id}>
                    <div className="table-content-item-name">
                      <span>{Item.Name}</span>
                      <i
                        className="feather-info"
                        onClick={() =>
                          handleModal(
                            Content.SubTitle,
                            Item.Name,
                            Item.ModalDescription
                          )
                        }
                      ></i>
                    </div>
                    <div
                      className={
                        "table-content-item-status " +
                        TableItems[Item.LabelId]?.Status
                      }
                    >
                      {TableItems[Item.LabelId]?.Status === "UP" ? "on" : "off"}
                    </div>
                    <div className="table-content-item-last-update">
                      {TableItems[Item.LabelId]?.LastUpdate
                        ? `${translateText("last_update_on", props.LangData)} ${
                            TableItems[Item.LabelId]?.LastUpdate
                          }`
                        : "Service unavailable"}
                    </div>
                  </div>
                ))}
              </div>
            ))}
      </div>
    </div>
  );
};

export default AIServiceMonitoring;
